import MUIButton from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

import cn from '@/utils/cn';

import type { ButtonProps } from '@/components/atoms/Button/buttonProps';
import ButtonWrapper from '@/components/atoms/Button/ButtonWrapper';

function Button<ComponentType extends Element = HTMLButtonElement>({
  id,
  label,
  primary,
  disabled,
  onClick,
  href,
  variant,
  withoutButtonStyling,
  type,
  className,
  color,
  form,
  startIcon,
  endIcon,
  loading,
  component,
  children,
  slotProps,
  splitButton,
  size,
}: ButtonProps<ComponentType>) {
  return (
    <ButtonWrapper
      enabled={
        splitButton && !!splitButton ? (true as const) : (false as const)
      }
      options={splitButton && !!splitButton ? splitButton.options : undefined}
      variant={primary ? 'contained' : variant ? variant : 'outlined'}
      color={color}
      className={cn(
        'rounded-tl-none! rounded-bl-none!',
        {
          '-mt-0.5 min-w-0 p-0 leading-none font-normal text-zinc-900 normal-case':
            variant === 'text' && withoutButtonStyling,
          'text-white': primary && color === 'salmon',
        },
        className
      )}
      ariaLabel={splitButton?.ariaLabel ?? ''}
    >
      <MUIButton
        variant={primary ? 'contained' : variant ? variant : 'outlined'}
        disabled={disabled || loading}
        onClick={onClick}
        href={href}
        type={type}
        id={id}
        color={color}
        form={form}
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        component={component}
        {...slotProps?.root}
        className={cn(
          {
            '-mt-0.5 min-w-0 p-0 leading-none font-normal text-zinc-900 normal-case':
              variant === 'text' && withoutButtonStyling,
            'text-white': primary && color === 'salmon',
            'rounded-tr-none! rounded-br-none!': splitButton && !!splitButton,
          },
          className
        )}
        size={size}
        disableFocusRipple
      >
        <span
          className={cn('flex items-center gap-2', slotProps?.root?.className)}
        >
          {startIcon && !loading ? startIcon : null}
          {loading && <CircularProgress size={20} />}
          {label || children}
          {endIcon && !loading ? endIcon : null}
        </span>
      </MUIButton>
    </ButtonWrapper>
  );
}

export default Button;
